export default __webpack_public_path__ + "static/media/1823.3f17e68a.png";